import { useMemo, useState } from 'react';

export function useSearch<T>(list: T[] | undefined, fields: (keyof T)[], initialValue?: string) {
  const [searchText, setSearchText] = useState(initialValue || "");

  const searchTextLowercase = useMemo(
    () =>
      searchText
        .toLowerCase()
        .split(' ')
        .filter((a) => a),
    [searchText]
  );

  const filteredList = useMemo(() => {
    const filtered = [] as T[];

    const l = list || [];

    // all keywords exact
    if (searchTextLowercase) {
      for (let i = 0; i < l.length; i += 1) {
        const line = l[i];

        let containsAllKeywordsExact = true;
        // each keyword has to be contained in at least one field
        for (let j = 0; j < searchTextLowercase.length; j += 1) {
          const keyword = searchTextLowercase[j];

          let keywordContained = false;
          for (let f = 0; f < fields.length; f += 1) {
            const fieldValue = String(line[fields[f]]).toLowerCase();

            if (fieldValue === keyword) {
              keywordContained = true;
              break;
            }
          }
          if (!keywordContained) {
            containsAllKeywordsExact = false;
            break;
          }
        }

        if (containsAllKeywordsExact && !filtered.includes(line)) {
          filtered.push(line);
        }
      }
    }

    // all keywords fuzzy
    for (let i = 0; i < l.length; i += 1) {
      const line = l[i];

      let containsAllKeywords = true;
      // each keyword has to be contained in at least one field
      for (let j = 0; j < searchTextLowercase.length; j += 1) {
        const keyword = searchTextLowercase[j];

        let keywordContained = false;
        for (let f = 0; f < fields.length; f += 1) {
          const fieldValue = String(line[fields[f]]).toLowerCase();

          if (fieldValue.indexOf(keyword) > -1) {
            keywordContained = true;
            break;
          }
        }
        if (!keywordContained) {
          containsAllKeywords = false;
          break;
        }
      }

      if (containsAllKeywords && !filtered.includes(line)) {
        filtered.push(line);
      }
    }
    return filtered;
  }, [fields, list, searchTextLowercase]);

  return {
    searchText,
    setSearchText,
    filteredList,
  };
}
